/**
 * Help-centre content, authored by the super-admin and read by every client.
 * Field names mirror the `help_articles` / `help_videos` / `help_whats_new`
 * tables (migration 0086) so no mapping layer is needed.
 */

export const HELP_CATEGORIES = [
    'Getting Started',
    'QR Codes',
    'Properties',
    'Leads',
    'Tours',
    'Buyer flow',
    'Billing',
    'Settings',
] as const;

export type HelpCategory = typeof HELP_CATEGORIES[number];

interface HelpRow {
    id:         string;
    /** Hidden entries stay in the admin list but never reach the Help panel. */
    published:  boolean;
    created_at: string;
    updated_at: string;
}

export interface HelpArticle extends HelpRow {
    category: string;
    title:    string;
    body:     string;
}

export interface HelpVideo extends HelpRow {
    title:    string;
    duration: string | null;
    url:      string | null;
}

export interface HelpWhatsNew extends HelpRow {
    /** `YYYY-MM-DD` the change shipped — what the panel sorts and shows. */
    published_on: string;
    title:        string;
    body:         string;
}

export interface HelpContent {
    articles: HelpArticle[];
    videos:   HelpVideo[];
    news:     HelpWhatsNew[];
}

/** Which collection an admin write targets. Matches the API's `:kind` param. */
export type HelpKind = keyof HelpContent;

export const EMPTY_HELP: HelpContent = { articles: [], videos: [], news: [] };
